import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Modal } from 'bootstrap'
import { authorizedCode, loginSuperUser } from '../../actions/user'
import Footer from '../../components/Footer/Footer'
import AuthorizeCodeModal from '../../components/modals/AuthorizeCodeModal/AuthorizeCodeModal'
import PasswordInput from '../../components/inputs/PasswordInput/PasswordInput'
import { useTitle } from '../../helpers/use_title.helper'
import './SuperUserLogin.css'

function SuperUserLogin () {
  useTitle('Ki | Super User Login')

  const user = useSelector((state) => state.user)
  const token = useSelector((state) => state.token)

  const dispatch = useDispatch()
  const history = useNavigate()
  const [newUser, setNewUser] = useState({
    email: '',
    password: ''
  })
  const [visiblePassword, setVisiblePassword] = useState(false)
  const [modalState, setModalState] = useState(null)
  const [superUserInfo, setSuperUserInfo] = useState(null)
  const modal = useRef()

  useEffect(() => {
    setModalState(new Modal(modal.current))
  }, [])
  useEffect(() => {
    let isActive = true
    if (isActive && user && user?._id && token) {
      history('/main')
    }
    return function cleanup () {
      isActive = false
    }
  }, [])

  function updateLocalStorage (data, objToUpdate, type) {
    window.localStorage.setItem(objToUpdate, JSON.stringify(data))
    dispatch({
      type,
      payload: data
    })
  }

  async function generateAuthenticationCode (e) {
    e.preventDefault()
    try {
      const generate = await loginSuperUser(newUser)
      if (generate.data) {
        setSuperUserInfo(generate.data)
        modalState.show()
      }
    } catch (e) {
      toast.error(e.response.data.message)
    }
  }

  async function handleCodeSubmit (code) {
    try {
      const authorizeCode = await authorizedCode(superUserInfo._id, code)
      if (authorizeCode.data) {
        authorizedUserHandler(authorizeCode.data)
      }
      modalState.hide()
    } catch (e) {
      modalState.hide()
      setNewUser({ ...newUser, password: '' })
      toast.error(e.response.data.message)
      toast.info('Genera nuevamente el código de autenticación')
    }
  }

  function handleChange (event) {
    const { name, value } = event.target

    setNewUser((prevData) => {
      return {
        ...prevData,
        [name]: value
      }
    })
  }

  function togglePasswordVisiblity () {
    setVisiblePassword(!visiblePassword)
  }

  function authorizedUserHandler (data) {
    const { user: u, token, client } = data
    updateLocalStorage(u, 'user', 'LOGGED_IN_USER')
    updateLocalStorage(token, 'token', 'LOGGED_IN_TOKEN')
    updateLocalStorage(client, 'client', 'LOGGED_IN_CLIENT')
    history('/main')
  }

  return (
    <div className='login-super'>
      <AuthorizeCodeModal
        modal={modal}
        modalState={modalState}
        onSubmit={handleCodeSubmit}
        user={newUser}
      />
      <div className='login-super-container container-fluid'>
        <form className='form login-form' onSubmit={generateAuthenticationCode}>
          <div className='form-title'>
            <h2>Super usuario</h2>
          </div>
          <div className='form-floating'>
            <input
              name='email'
              type='email'
              className='form-control'
              id='floatingEmail'
              placeholder='Correo Electrónico'
              value={newUser.email}
              onChange={handleChange}
              autoComplete='username'
              required
            />
            <label htmlFor='floatingEmail'>Correo Electrónico</label>
          </div>
          <PasswordInput
            visiblePassword={visiblePassword}
            togglePasswordVisiblity={togglePasswordVisiblity}
            handleChange={handleChange}
            value={newUser.password}
            name='password'
            text='Contraseña'
          />
          <button type='submit' className='btn main-btn'>Iniciar Sesión</button>
        </form>

        <Footer />
      </div>
    </div>
  )
}

export default SuperUserLogin
